import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import BetTableRace2 from "../../casinoComponents/betTableRace2";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import MyBet from "../../casinoComponents/myBet";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import Race2CardsOverlay from "../../casinoComponents/videoBox/overlays/Race2CardsOverlay";
import ResultRace2 from "../resultui/resultRace2/ResultRace2";
import {
  getCasinoGameDetails,
  getMatchExposure,
  getCasinoOpenBets,
} from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/race2.css";

// Reference (allpanel9 admin casino/race2) title: "Race 2" until the last-results feed gives res1.cname
const RACE2_TITLE = "Race to 2nd";

// Reference v-kvalmin / v-kvalmax
const kval = (n) => {
  const v = Number(Number(n || 0).toFixed(2));
  if (v >= 1e3 && v < 1e5) return `${parseFloat((v / 1e3).toFixed(2))}K`;
  if (v >= 1e5) return `${parseFloat((v / 1e5).toFixed(2))}L`;
  return parseFloat(v);
};

export default function Race2() {
  const [gameData, setGameData] = useState(null);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  const [showCards, setShowCards] = useState(true);
  const [title, setTitle] = useState(RACE2_TITLE);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "race2";
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`;

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(gameName);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [gameName]);

  const matchIdOf = (gd) =>
    gd?.data?.data?.mid?.toString() || gd?.data?.mid?.toString() || gd?.mid?.toString();
  const matchId = matchIdOf(gameData);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const amount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              exposureMap[teamName] = amount;
              exposureMap[teamName.toLowerCase()] = amount;
              exposureMap[teamName.trim()] = amount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [matchId]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype:
            bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets:", error);
    }
  }, [gameName]);

  useEffect(() => {
    if (!matchId) return undefined;
    const t = setTimeout(fetchExposure, 0);
    const exposureInterval = setInterval(fetchExposure, 2000);
    return () => {
      clearTimeout(t);
      clearInterval(exposureInterval);
    };
  }, [matchId, fetchExposure]);

  useEffect(() => {
    const t = setTimeout(fetchMyBetsData, 0);
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => {
      clearTimeout(t);
      clearInterval(intervalId);
    };
  }, [fetchMyBetsData]);

  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const casinoData = gameData?.data?.data;
  const subData = casinoData?.sub || gameData?.data?.sub || gameData?.sub || [];
  const main = [...subData]
    .filter((s) => !s?.subtype || s.subtype === "race2")
    .sort((a, b) => (a?.sr ?? 0) - (b?.sr ?? 0));
  const roundId = casinoData?.mid || gameData?.data?.mid || gameData?.mid || "";
  const cardString = casinoData?.card ?? casinoData?.t1?.card ?? "";
  // new round (first card face-down again) re-opens a hand-closed strip
  if (String(cardString).split(",")[0].trim() === "1" && !showCards) setShowCards(true);
  const remark = casinoData?.remark;
  const resultData = gameData?.lrs ?? casinoData?.lrs ?? gameData?.data?.lrs ?? [];

  return (
    <CasinoTableLayout
      tableClass="casino-queen"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name={title} roundId={casinoData?.mid ?? ""} />{" "}
        <VideoBox
          gameType="race2"
          iframeSrc={iframeSrc}
          timerValue={casinoData?.lt}
          roundId={roundId}
          cardsOverlay={
            <Race2CardsOverlay
              cardString={cardString}
              subData={main}
              showCards={showCards}
              onToggle={() => setShowCards((s) => !s)}
            />
          }
        />{" "}
        {roundId ? (
          <div className="casino-detail">
            <BetTableRace2 onBetClick={handleBetClick} data={main} exposures={exposures} />{" "}
            <div className="col-12 text-right casino-min-max">
              R:<span>{kval(main[0]?.min)}</span>-<span>{kval(main[0]?.max)}</span>
            </div>{" "}
            {remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} />
                </div>{" "}
                <marquee>{remark}</marquee>
              </div>
            ) : null}{" "}
            <CasinoLastResult
              gameType="race2"
              resultComponent={<ResultRace2 data={resultData} gameType="race2" onTitle={setTitle} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
      />
    </CasinoTableLayout>
  );
}
